<template>
  <div :class="`local-priority-item ${isSelected ? 'local-priority-item_active' : ''} `"
       v-tooltip.bottom="examplesString"
       @click="$emit('click', {level: item.level, priority: item.priority})">
    <v-text-field v-if="isEdit"
                  v-model="localPriorityName"
                  class="local-priority-item-label local-priority-item-input  font-28 no-margin height-43"
                  type="text"
                  ref="textField"
                  :height="43"
                  @blur="setLabel"></v-text-field>
    <p v-else
       class="local-priority-item-label"
       @dblclick="setEdit">{{ localPriorityName }}</p>
    <p class="local-priority-item-icon">></p>
  </div>
</template>

<script>
import EventBus from "@packages/event-bus";

export default {
  props: {
    item: {
      type: Object,
    },
    currentLevel: {
      type: Number,
    },
  },
  data() {
    return {
      isEdit: false,
      localPriorityName: this.item.label,
      localPriorityItem: { ...this.item },
    };
  },

  mixins: [],

  computed: {
    examplesString() {
      return this.localPriorityItem.examples
        ? this.localPriorityItem.examples.join()
        : "";
    },
    isSelected() {
      return this.currentLevel === this.item.level;
    },
    user() {
      return this.$store.state.users.user;
    },
    isMasterUser() {
      return this.user.permissions.includes("MASTER");
    },
  },

  watch: {
    item(val) {
      (this.localPriorityName = val.label),
        (this.localPriorityItem = { ...val });
    },
  },

  methods: {
    async setLabel() {
      if (this.localPriorityName.length <= 0) {
        this.localPriorityName = this.item.label;

        return EventBus.$emit("show-message", {
          type: "ERROR",
          message: "O nome não pode ser vazio.",
        });
      }

      try {
        const res = await this.$api.localPriority.alterLabel({
          level: this.localPriorityItem.level,
          label: this.localPriorityName,
        });

        this.localPriorityItem.label = this.localPriorityName;

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: res.message,
          timeout: 2000,
        });
      } catch (error) {
        this.localPriorityName = this.localPriorityItem.label;
        console.log(error);
      }
    },
    setEdit() {
      if (this.isMasterUser && this.item.level !== 0) {
        this.isEdit = true;

        this.$nextTick(() => {
          this.$refs.textField.focus();
        });
      }
    },
  },

  created() {
    window.addEventListener("click", (e) => {
      // close dropdown when clicked outside
      if (!this.$el.contains(e.target)) {
        this.isEdit = false;
      }
    });
  },

  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "~wifeed-shared/styles/variables";

.local-priority-item {
  display: flex;
  align-items: center;
  cursor: pointer;

  .local-priority-item-label {
    padding-top: 0 !important;
  }

  .local-priority-item-input {
    width: 200px;
  }

  p {
    user-select: none;
    font-size: 28px;
    margin: 0;
    color: $grey-4;
  }

  .local-priority-item-icon {
    margin: 0 5px;
  }

  &.local-priority-item_active {
    .local-priority-item-label {
      font-weight: 600;
    }
  }

  &:last-child {
    .local-priority-item-icon {
      display: none;
    }
  }
}
</style>
